module.exports = __webpack_public_path__ + "static/media/footer-ico3.2a36f50d.svg";